import { sendPost } from './generic';

export interface FormFillField {
    websiteUrl: string;
    prompt: string;
    associatedVariable: string;
}

export interface FormFillResponse {
    associatedVariable: string;
    value: string;
    sourceUrl: string;
}

export const autoGenerateFormFieldValues = (organizationId: string, field: FormFillField) =>
    sendPost<FormFillResponse>(`/formfill/${organizationId}`, field);

